
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import Icon from 'JS/components/Icon.vue';

@Component({
	name: 'BuyAgainMessage',
	components: {
		Icon,
	}
})
class BuyAgainMessage extends Vue {
	@Prop({ type: String, default: '' })
	messageFirstLine: string

	@Prop({ type: String, default: '' })
	messageSecondLine: string
}

export default BuyAgainMessage;
